import React from 'react';

import { faLaughBeam, faSmile, faFrown, faTired, faMeh, faThumbsUp, faThumbsDown } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { scrollElementToTop } from './Common.js'

export function handleChange(event) {
  let name = event.target.name;
  let value = event.target.value;
  this.setState({[name]: value});
}

//arriving/leaving

export function requiredString(key, otherOptions = "") {
  if (key === true) {
    return "required|" + otherOptions;
  }
  else {
    return otherOptions
  }
}

export function renderRequired(key) {
  if (key === true) {
    return (
      <span className="red">*</span>
    )
  }
}

export function directionHandler(_this) {
  if (_this.state.direction === "leaving") {
    return "departure"
  }
  else {
    return "arrival"
  }
}

export function directionPluralHandler(_this) {
  if (_this.state.direction === "leaving") {
    return "departures"
  }
  else {
    return "arrivals"
  }
}

export function directionCheckHandler(_this) {
  if (_this.state.direction === "leaving") {
    return "check_out_time"
  }
  else {
    return "check_in_time"
  }
}

//feedback

export function handleRadio(event) {
  let name = event.target.name;
  let value = parseInt(event.target.value);

  this.setState({[name]: value});
}

export function getFeedbackForDirection(_this) {
  let profile = _this.props.location.state.profile
  let direction = _this.props.location.state.direction

  let showOn = direction === "arriving" ? "Arrival" : "Departure"

  var feedbackTypes = []
  profile.feedback_types.forEach((feedback) => {
    if (feedback.show_on === showOn) {
      feedbackTypes.push(feedback)
    }
  })

  return feedbackTypes
}

export function getAnonymousQuestionIds(_this) {
  let feedbackTypes = getFeedbackForDirection(_this)
  let anonymousFeedback = feedbackTypes.filter((feedback) => feedback.anonymous === true)

  var anonymousQuestionIds = []
  anonymousFeedback.forEach((feedback) => {
    feedback.feedback_questions.forEach((question) => {
      anonymousQuestionIds.push(question.id)
    })
  })

  return anonymousQuestionIds
}

export function answerForm(question, _this) {
  if (question.answer_type === "boolean") {
    return (
      <div className="question radio radio-card" key={question.id}>
        <div className="question-title">{question.display}</div>
        <input className="column no" type="checkbox" name={question.id} value="no" id={`no_${question.id}`} checked={_this.state.answers[question.id] === "no"} onChange={_this.handleFeedbackChange} />
        <label className="longer" htmlFor={`no_${question.id}`}>No</label>
        { question.answer_quantity === 3 &&
          <>
            <input className="column na" type="checkbox" name={question.id} value="n/a" id={`na_${question.id}`} checked={_this.state.answers[question.id] === "n/a"} onChange={_this.handleFeedbackChange} />
            <label className="longer" htmlFor={`na_${question.id}`}>N/A</label>
          </>
        }
        <input className="column yes" type="checkbox" name={question.id} value="yes" id={`yes_${question.id}`} checked={_this.state.answers[question.id] === "yes"} onChange={_this.handleFeedbackChange} />
        <label className="longer" htmlFor={`yes_${question.id}`}>Yes</label>
      </div>
    )
  }

  if (question.answer_type === "stars") {
    let numberOfStars = _this.state.answers[question.id]
    var iconType = []

    for (var i = 0; i < numberOfStars; i++) {
      iconType.push("fas")
    }

    return (
      <div className="question radio radio-card" key={question.id}>
        <div className="question-title">{question.display}</div>

        <div className="mobile-stars">
          <input className="column" type="checkbox" name={question.id} value="1" id={`one_star_${question.id}_mobile`} checked={_this.state.answers[question.id] === "1"} onChange={_this.handleFeedbackChange} />
          <label htmlFor={`one_star_${question.id}_mobile`}>
            <FontAwesomeIcon icon={[iconType[0] || "far", "star"]} style={{color: iconType[0] ? "gold" : "#777"}} />
          </label>
          <input className="column" type="checkbox" name={question.id} value="2" id={`two_stars_${question.id}_mobile`} checked={_this.state.answers[question.id] === "2"} onChange={_this.handleFeedbackChange} />
          <label htmlFor={`two_stars_${question.id}_mobile`}>
            <FontAwesomeIcon icon={[iconType[1] || "far", "star"]} style={{color: iconType[1] ? "gold" : "#777"}} />
          </label>
          { question.answer_quantity !== 4 &&
            <>
              <input className="column" type="checkbox" name={question.id} value="3" id={`three_stars_${question.id}_mobile`} checked={_this.state.answers[question.id] === "3"} onChange={_this.handleFeedbackChange} />
              <label htmlFor={`three_stars_${question.id}_mobile`}>
                <FontAwesomeIcon icon={[iconType[2] || "far", "star"]} style={{color: iconType[2] ? "gold" : "#777"}} />
              </label>
            </>
          }
          <input className="column" type="checkbox" name={question.id} value="4" id={`four_stars_${question.id}_mobile`} checked={_this.state.answers[question.id] === "4"} onChange={_this.handleFeedbackChange} />
          <label htmlFor={`four_stars_${question.id}_mobile`}>
            <FontAwesomeIcon icon={[iconType[3] || "far", "star"]} style={{color: iconType[3] ? "gold" : "#777"}} />
          </label>
          <input className="column" type="checkbox" name={question.id} value="5" id={`five_stars_${question.id}_mobile`} checked={_this.state.answers[question.id] === "5"} onChange={_this.handleFeedbackChange} />
          <label htmlFor={`five_stars_${question.id}_mobile`}>
            <FontAwesomeIcon icon={[iconType[4] || "far", "star"]} style={{color: iconType[4] ? "gold" : "#777"}} />
          </label>
        </div>
      </div>
    )
  }

  if (question.answer_type === "text") {
    return (
      <div className="question text form" key={question.id}>
        <div className="question-title">{question.display}</div>
        <textarea aria-required="true" name={question.id} value={_this.state.answers[question.id]} onChange={_this.handleFeedbackChange} />
      </div>
    )
  }

  if (question.answer_type === "smileys") {
    return (
      <div className="question radio radio-card" key={question.id}>
        <div className="question-title">{question.display}</div>

        <div className="smileys">
          <span className="very_unhappy">
            <input className="column" type="checkbox" name={question.id} value="1" id={`very_unhappy_${question.id}`} checked={_this.state.answers[question.id] === "1"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`very_unhappy_${question.id}`}>
              <FontAwesomeIcon icon={faTired} />
            </label>
          </span>
          <span className="unhappy">
            <input className="column" type="checkbox" name={question.id} value="2" id={`unhappy_${question.id}`} checked={_this.state.answers[question.id] === "2"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`unhappy_${question.id}`}>
              <FontAwesomeIcon icon={faFrown} />
            </label>
          </span>
          { question.answer_quantity === 5 &&
            <span className="yellow">
              <input className="column" type="checkbox" name={question.id} value="3" id={`neutral_${question.id}`} checked={_this.state.answers[question.id] === "3"} onChange={_this.handleFeedbackChange} />
              <label htmlFor={`neutral_${question.id}`}>
                <FontAwesomeIcon icon={faMeh} />
              </label>
            </span>
          }
          <span className={question.answer_quantity === 5 ? "light-green" : "yellow"}>
            <input className="column" type="checkbox" name={question.id} value="4" id={`happy_${question.id}`} checked={_this.state.answers[question.id] === "4"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`happy_${question.id}`}>
              <FontAwesomeIcon icon={faSmile} />
            </label>
          </span>
          <span className="very_happy">
            <input className="column" type="checkbox" name={question.id} value="5" id={`very_happy_${question.id}`} checked={_this.state.answers[question.id] === "5"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`very_happy_${question.id}`}>
              <FontAwesomeIcon icon={faLaughBeam} />
            </label>
          </span>
        </div>
      </div>
    )
  }

  if (question.answer_type === "thumbs") {
    return (
      <div className="question radio radio-card" key={question.id}>
        <div className="question-title">{question.display}</div>

        <div className="smileys thumbs">
          <span className="very_unhappy">
            <input className="column" type="checkbox" name={question.id} value="1" id={`very_unhappy_${question.id}`} checked={_this.state.answers[question.id] === "1"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`very_unhappy_${question.id}`}>
              <FontAwesomeIcon icon={faThumbsDown} />
              <FontAwesomeIcon icon={faThumbsDown} />
            </label>
          </span>
          <span className="unhappy">
            <input className="column" type="checkbox" name={question.id} value="2" id={`unhappy_${question.id}`} checked={_this.state.answers[question.id] === "2"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`unhappy_${question.id}`}>
              <FontAwesomeIcon icon={faThumbsDown} />
            </label>
          </span>
          { question.answer_quantity === 5 &&
            <span className="yellow">
              <input className="column" type="checkbox" name={question.id} value="3" id={`neutral_${question.id}`} checked={_this.state.answers[question.id] === "3"} onChange={_this.handleFeedbackChange} />
              <label htmlFor={`neutral_${question.id}`}>
                <FontAwesomeIcon icon={faThumbsUp} className="rotate-90" />
              </label>
            </span>
          }
          <span className={question.answer_quantity === 5 ? "light-green" : "yellow"}>
            <input className="column" type="checkbox" name={question.id} value="4" id={`happy_${question.id}`} checked={_this.state.answers[question.id] === "4"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`happy_${question.id}`}>
              <FontAwesomeIcon icon={faThumbsUp} />
            </label>
          </span>
          <span className="very_happy">
            <input className="column" type="checkbox" name={question.id} value="5" id={`very_happy_${question.id}`} checked={_this.state.answers[question.id] === "5"} onChange={_this.handleFeedbackChange} />
            <label htmlFor={`very_happy_${question.id}`}>
              <FontAwesomeIcon icon={faThumbsUp} />
              <FontAwesomeIcon icon={faThumbsUp} />
            </label>
          </span>
        </div>
      </div>
    )
  }

  if (question.answer_type === "net_promoter") {
    return (
      <div className="question radio" key={question.id}>
        <div className="question-title">{question.display}</div>

        <div className="net-promoter">
          {["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map(value => {
            const inputId = `${value}_${question.id}`;
            
            return (
              <React.Fragment key={inputId}>
                <input className="column" type="checkbox" name={question.id} value={value} id={inputId} checked={_this.state.answers[question.id] === value} onChange={_this.handleFeedbackChange} />
                <label htmlFor={inputId}>{value}</label>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    )
  }

  if (question.answer_type === "multi_select") {
    return (
      <div className="question" key={question.id}>
        <div className="question-title">{question.display}</div>

        <div className="options" style={{gridTemplateColumns: organiseColumns(question.options)}}>
          {question.options.map((option, index) =>
            <div className="option" key={index}>
              <input className="column" type="checkbox" name={question.id} value={index} id={`option#${question.id}-${index}`} checked={_this.state.answers[question.id] ? _this.state.answers[question.id].includes(index) : false} onChange={_this.handleMultiSelectCheckbox} />
              <label htmlFor={`option#${question.id}-${index}`}>{option}</label>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export function organiseColumns(options) {
  if (options.length < 6) {
    return options.map(option => "1fr").join(" ")
  }

  for (let gridWidth = 5; gridWidth > 2; gridWidth--) {
    if (options.length % gridWidth === 0) {
      return new Array(gridWidth).fill("1fr").join(" ")
    }
  }

  return "1fr 1fr 1fr 1fr 1fr"
}

export function handleFeedbackChange(event) {
  if ((new Date() - this.state.initialTime) < (parseInt(process.env.REACT_APP_INTERACTION_DELAY) || 0)) {
    return
  }

  let name = event.target.name;
  let value = event.target.value;
  let tag = event.target.tagName;

  if (this.state.answers[name] === value) {
    let answers = this.state.answers
    delete answers[name]

    this.setState({answers: answers})
  }
  else {
    this.setState(existingState => ({
      answers: {
        ...existingState.answers,
        [name]: value
      }
    }))
  }

  if (tag === "TEXTAREA") {
    this.debouncedScrollElementToTop(event.target)
  }
  else {
    scrollElementToTop(event.target)
  }
}

export function handleMultiSelectCheckbox(event) {
  let name = event.target.name;
  let value = parseInt(event.target.value);
  let checked = event.target.checked;

  var answers = this.state.answers

  answers[name] ||= []

  if (checked === true) {
    if (!answers[name].includes(value)) {
      answers[name].push(value)
    }
  }
  else if (checked === false) {
    if (answers[name].includes(value)) {
      let index = answers[name].indexOf(value)
      answers[name].splice(index, 1)
    }
  }

  if (answers[name].length === 0) {
    delete answers[name]
  }

  this.setState({ answers });

  scrollElementToTop(event.target)
}

export function renderQuestion(question, feedback_type, _this) {
  const follow_ons = feedback_type.feedback_questions.filter(feedback_question => feedback_question.depends_on_question_id === question.id)

  return (
    <React.Fragment key={question.id}>
      {answerForm(question, _this)}

      {follow_ons.filter(follow_on => askConditionMet(follow_on, question, _this)).map((follow_on) => {
        return renderQuestion(follow_on, feedback_type, _this)
      })}
    </React.Fragment>
  )
}

export function askConditionMet(follow_on_question, depends_on_question, _this) {
  let answer = _this.state.answers[depends_on_question.id]

  if (answer === undefined || answer === "") {
    return false
  }

  const { depends_on_score, depends_on_condition } = follow_on_question;

  if (depends_on_score === null || depends_on_condition === null) {
    return true
  }

  if (depends_on_question.answer_type === "text") {
    return true
  }

  // Boolean answers are "yes" "no" or "n/a" and other scored answers are 1..5 instead of -2..2
  // We'll normalize them here before we continue
  if (depends_on_question.answer_type === "boolean") {
    if (answer === "yes") {
      answer = 2
    }
    else if (answer === "no") {
      answer = -2
    }
    else if (answer === "n/a") {
      answer = 0
    }
  }
  else if (["stars", "smileys", "thumbs"].includes(depends_on_question.answer_type)) {
    answer = parseInt(answer) - 3
  }

  if (depends_on_question.answer_type === "net_promoter") {
    if (["0","1", "2", "3", "4", "5", "6"].includes(answer)) {
      answer = -2
    }
    else if (["7", "8"].includes(answer)) {
      answer = 0
    }
    else if (["9", "10"].includes(answer)) {
      answer = 2
    }
  }

  switch (depends_on_condition) {
    case "or_worse":
      return parseInt(answer) <= depends_on_score
    case "or_better":
      return parseInt(answer) >= depends_on_score
    default:
      if (parseInt(answer) === depends_on_score) {
        return true
      }
  }

  // These conditions are impossible to fulfil with the current setup, so we'll treat them as "any answer":
  if (depends_on_question.answer_type === "boolean" && [-1,1].includes(depends_on_score)) {
    return true
  }
  else if (["stars", "smileys", "thumbs"].includes(depends_on_question.answer_type) && depends_on_question.answer_quantity === 4 && depends_on_score === 0) {
    return true
  }

  return false
}

export function anonymousMessage(anonymous) {
  if (anonymous === true) {
    return (
      <div className="anonymous-text">
        This feedback is anonymous. It will not be saved against your name.
      </div>
    )
  }
}

export function compileAnswers(key) {
  if (typeof this.state.answers[key] === "string") {
    return this.state.answers[key]
  }

  const question = this.props.location.state.feedbackTypes.flatMap(ft => ft.feedback_questions).find(item => item.id.toString() === key)

  return this.state.answers[key].map(index => question.options[index]).join("\n")
}

//vistingwho

export function handleMultiCheckbox(event) {
  let name = parseInt(event.target.name);
  let value = event.target.checked;

  var people_ids = this.state.people_ids

  if (value === true) {
    if (!people_ids.includes(name)) {
      people_ids.push(name)
    }
  }
  else if (value === false) {
    if (people_ids.includes(name)) {
      let index = people_ids.indexOf(name)
      people_ids.splice(index, 1)
    }
  }

  this.setState({
    people_ids: people_ids,
  });
}

export function skipOrSelectText(people_ids, typed_names, submit_button_value) {
  return people_ids.length === 0 && typed_names.join("") === "" ? "Not visiting anyone" : submit_button_value
}

export function selectPersonText(relationships) {
  let quantity = relationships.length === 1 ? "person" : "people"

  return `Select which ${quantity} you're visiting`
}

//information
export function handleCheckbox(event) {
  let name = event.target.name;
  let value = event.target.checked;

  this.setState({[name]: value});
}

export function handleValidationSubmit(event) {
  if (this.validator.allValid()) {
    this.setState({validDetails: true})
  }
  else {
    this.validator.showMessages();
    this.forceUpdate();
  }

  event.preventDefault();
}

export function sanitizeString(string) {
  if (typeof string !== "string") {
    return string
  }

  const replaced = string.replace(/[^\w]/g, "")

  if (string.length > 0 && replaced.length === 0) {
    // Provided data was made up of entirely non-alphanumeric character. We want to avoid replacing it with an empty string
    // as that would cause issues in the later `safeStringComparison` function, which counts empty strings as a match.
    //
    // `string = "----"` means `replaced = ""` which means we should return "----".

    return string
  }
  else {
    return replaced
  }
}

export function safeStringComparison(record, incoming) {
  // First argument needs to be localStorage record so that comparisons can be ignored when that value is null.
  if (typeof record === "string" && typeof incoming === "string") {
    if (record === "") {
      return true
    }
    return (record.trim().toUpperCase() === incoming.trim().toUpperCase())
  }
  else if (record === null) {
    return true
  }
  else return false
}

export function safeSubstringFuzzyComparison(record, value) {
  // First argument needs to be localStorage record so that comparisons can be ignored when that value is null.
  if (typeof record === "string" && typeof value === "string") {
    if (record === "" || value === "") {
      return true
    }
    return (record.trim().toUpperCase().substr(0, value.trim().length) === value.trim().toUpperCase())
  }
  else if (record === null) {
    return true
  }
  else return false
}

export function splitAlternativeNameSubstringComparison(alternate_names, value) {
  if (alternate_names === undefined || alternate_names === null || alternate_names === "") {
    return false
  }

  let matchFound = false

  alternate_names.split(",").forEach((record) => {
    if (safeSubstringFuzzyComparison(sanitizeString(record), sanitizeString(value)) === true) {
      matchFound = true
      return
    }
  })

  return matchFound
}


export function safeSubstringActiveComparison(record, value) {
  // Ignore empty input fields
  if (value.trim().length === 0) {
    return true
  }
    return ((record && record.trim().toUpperCase().substr(0, value.trim().length)) === value.trim().toUpperCase())
}
